import { render, staticRenderFns } from "./renwufwlistitem.vue?vue&type=template&id=ce8bbd64&class=component&"
import script from "./renwufwlistitem.vue?vue&type=script&lang=js&"
export * from "./renwufwlistitem.vue?vue&type=script&lang=js&"
import style0 from "./renwufwlistitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8bbd64')) {
      api.createRecord('ce8bbd64', component.options)
    } else {
      api.reload('ce8bbd64', component.options)
    }
    module.hot.accept("./renwufwlistitem.vue?vue&type=template&id=ce8bbd64&class=component&", function () {
      api.rerender('ce8bbd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/renwufwlistitem.vue"
export default component.exports